import axios from 'axios';
import { devLog } from '../functions';
import { ActionTypes, ProductTypes } from '../constants';
import { catchError } from './';

export const getCalendar = (calendarMode = null) => async dispatch => {
  //PHP initalaze
  if (calendarMode === null && 'initialCalendar' in window) {
    devLog('getCalendar: window.initialCalendar');
    dispatch({
      type: ActionTypes.GET_CALENDAR,
      calendar: window.initialCalendar
    });
  } else {
    let productTypeId = ProductTypes.PostingFlyer;
    if ('productTypeId' in window) {
      productTypeId = window.productTypeId;
    }
    let errFlg = false;
    const response = await axios({
      method: 'POST',
      withCredentials: true,
      url: process.env.REACT_APP_API_URL + '',
      data: {
        mode: 'get_calendar',
        product_type_id: productTypeId,
        calendar_mode: calendarMode
      }
    }).catch(e => {
      errFlg = catchError(e);
    });
    if (errFlg) return;

    if (typeof response === 'object' && 'data' in response) {
      devLog('get_calendar', response.data);
      dispatch({ type: ActionTypes.GET_CALENDAR, calendar: response.data });
    } else {
      devLog('response', response);
    }
  }
};

export const selectCalendarDate = date => dispatch => {
  dispatch({ type: ActionTypes.SELECT_CALENDAR_DATE, selected: date });
  // dispatch(calcPrice())
};

// カレンダーモードの設定
export const setCalendarMode = mode => dispatch => {
  dispatch({ type: ActionTypes.SET_CALENDAR_MODE, mode });
};

// カレンダーモードの設定値を取得
export const getCalendarRules = () => async dispatch => {
  //PHP initalaze
  if ('initialCalendarRules' in window) {
    devLog('getCalendar: window.initialCalendarRules');
    dispatch({
      type: ActionTypes.GET_CALENDAR_RULES,
      calendarRules: window.initialCalendarRules
    });
  } else {
    let errFlg = false;
    const response = await axios({
      method: 'POST',
      withCredentials: true,
      url: process.env.REACT_APP_API_URL + '',
      data: {
        mode: 'get_calendar_rules'
      }
    }).catch(e => {
      errFlg = catchError(e);
    });
    if (errFlg) return;

    if (typeof response === 'object' && 'data' in response) {
      devLog('get_calendar_rules', response.data);
      dispatch({
        type: ActionTypes.GET_CALENDAR_RULES,
        calendarRules: response.data
      });
    } else {
      devLog('response', response);
    }
  }
};



// WEBPACK FOOTER //
// ./src/actions/calendar.js